<template>
    <RegisterStep
        :ready="ready"
        :loading="loading"
        :previous-route="previousRoute"
        v-bind="$attrs"
        @submit="handleStepSubmitted"
    >
        <template v-if="currentOrder.third_party">
            <dl class="mb-4">
                <template v-for="meal in session.meals">
                    <template v-if="meal.detail">
                        <dt>{{ meal.name }}</dt>
                        <dd style="font-size: .875rem">{{ meal.detail }}</dd>
                    </template>
                </template>
            </dl>
        </template>

        <RegistrantSections :order="currentOrder" v-slot="{ registrant, i }">
            <RegistrantCard :registrant="registrant" :order="order">
                <div class="mb-n4">
                    <template v-for="(meal, j) in session.meals">
                        <Field class="mb-4" :name="`registrants.${i}.meals.${j}`" :errors="errors" v-slot="{ error }">
                            <div class="mb-2">{{ meal.name }}</div>

                            <b-form-radio-group
                                class="cursus-radios cursus-radios--small"
                                :checked="priceIndex(registrant, meal)"
                                stacked
                                @change="handlePriceIndexChanged(registrant, meal, $event)"
                            >
                                <template v-for="(price, k) in meal.prices">
                                    <b-form-radio :value="k">
                                        <span class="d-block">
                                            {{ price.label }}
                                            <template v-if="price.amount">
                                                : <strong>{{ price.formatted_amount }}</strong>
                                            </template>
                                        </span>
                                    </b-form-radio>
                                </template>
                            </b-form-radio-group>

                            <template v-if="meal.detail && !currentOrder.third_party">
                                <div class="cursus-help cursus-help--small text-muted mt-2">
                                    {{ meal.detail }}
                                </div>
                            </template>
                        </Field>
                    </template>
                </div>
            </RegistrantCard>
        </RegistrantSections>
    </RegisterStep>
</template>

<script>
    import { clone } from "../../../util";
    import { BFormRadio, BFormRadioGroup } from 'bootstrap-vue';
    import { postOrderMeals } from "../../../api";
    import RegisterStep from "../RegisterStep.vue";
    import RegistrantSections from "../RegistrantSections.vue";
    import Field from "../../Field.vue";
    import { nextStep, registerSteps } from "../../../util/register";
    import RegistrantCard from "../RegistrantCard.vue";

    export default {
        components: {
            RegistrantCard,
            Field,
            RegistrantSections,
            RegisterStep,
            BFormRadio,
            BFormRadioGroup,
        },
        props: {
            order: Object,
            session: Object,
            course: Object,
            previousRoute: Object,
        },
        data() {
            return {
                ready: false,
                currentOrder: clone(this.order),
                loading: false,
                errors: null,
            }
        },
        methods: {
            post({ nextStep }) {
                const { courseId, sessionId, orderId } = this.$route.params;
                this.loading = true;
                this.errors = null;

                return postOrderMeals({
                    courseId,
                    sessionId,
                    orderId,
                    data: {
                        ...this.currentOrder,
                        next_step: nextStep?.value,
                    },
                })
                .catch(error => {
                    if(error.response?.status === 422) {
                        this.errors = error.response.data.errors;
                    }
                    return Promise.reject(error);
                })
                .finally(() => {
                    this.loading = false;
                });
            },
            async handleStepSubmitted() {
                this.nextStep = this.getNextStep();
                this.nextRoute = this.nextStep.route;

                const order = await this.post({
                    nextStep: this.nextStep,
                });

                this.currentOrder = order;
                this.$emit('update:order', order);

                await this.$router.push(this.nextRoute);
            },
            priceIndex(registrant, meal) {
                return registrant.meals.find(value => value.id === meal.id)?.price_index;
            },
            handlePriceIndexChanged(registrant, meal, price_index) {
                const price = meal.prices[price_index];
                registrant.meals = registrant.meals.map(value =>
                    value.id === meal.id
                        ? { ...value, price_index, price_amount: price?.amount }
                        : value
                );
            },
            getNextStep() {
                const steps = registerSteps({
                    order: this.currentOrder,
                    course: this.course,
                    session: this.session,
                });
                // force going to next adjacent step (e.g. go to checkout if prices changed)
                return nextStep(steps, this.$route);
            },
            init() {
                this.currentOrder.registrants = this.currentOrder.registrants.map(registrant => ({
                    ...registrant,
                    meals: registrant.meals?.length > 0
                        ? registrant.meals
                        : this.session.meals.map(meal => ({
                            id: meal.id,
                            price_index: 0,
                            price_amount: meal.prices[0]?.amount,
                        }))
                }));
                this.ready = true;
            }
        },
        created() {
            this.init();
        },
    }
</script>
